export const GET_PROCESS_INSTANCE = 'EPIC/GET_PROCESS_INSTANCE';
export const GET_PROCESS_INSTANCE_SUCCESS = 'EPIC/GET_PROCESS_INSTANCE_SUCCESS';
export const GET_PROCESS_INSTANCE_FAILURE = 'EPIC/GET_PROCESS_INSTANCE_FAILURE';
